import getMinuteTimestamp from './getMinuteTimestamp';

const appendMinuteTimestamp = (url) => {
  const timestamp = getMinuteTimestamp();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${timestamp}`;
};

export default appendMinuteTimestamp;
